import * as actions from './documents.actions';
import { SortInfo } from '../../global/interfaces';

import * as moment from 'moment';
import { DocumentsData } from '../statements/statements.models';
import { DOCUMENTS_TABS, DocumentsFilter } from './documents.models';
import { PaginationInfo } from 'atlas-pagination';


export interface State {
  loading: boolean;
  documents: DocumentsData;
  mobile: DocumentsData;
  mobilePagination: PaginationInfo;
  filter: DocumentsFilter;
  pagination: PaginationInfo;
  sort: SortInfo;
}

export const initialState: State = {
  loading: false,
  documents: {
    data: [],
    total: 0
  },
  mobile: {
    data: [],
    total: 0
  },
  mobilePagination: {
    page: 1,
    itemsByPage: 10,
    total: 0,
  },
  filter: {
    type: DOCUMENTS_TABS[0],
    from: moment().month('January').startOf('month').utc().format('YYYY-MM-DD'),
    to: moment().utc().format('YYYY-MM-DD'),
  },
  sort: {
    column: 'date',
    reverse: true
  },
  pagination: {
    page: 1,
    itemsByPage: 10,
    total: 0,
  }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_DOCUMENTS:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_DOCUMENTS_SUCCESS:
      return { ...state, loading: false, documents: action.payload };
    case actions.ActionTypes.LOAD_DOCUMENTS_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.LOAD_MOBILE_DOCUMENTS:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_MOBILE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        mobile: {
          total: action.payload.total,
          data: [...state.mobile.data, ...action.payload.data]
        }
      };
    case actions.ActionTypes.LOAD_MOBILE_DOCUMENTS_FAILED:
      return { ...state, loading: false };
    case actions.ActionTypes.SET_DOCUMENTS_MOBILE_PAGINATION:
      return { ...state, mobilePagination: action.payload };

    case actions.ActionTypes.SET_DOCUMENTS_FILTER:
      return { ...state, filter: action.payload };
    case actions.ActionTypes.SET_DOCUMENTS_TYPE:
      return { ...state, filter: { ...state.filter, type: action.payload } };
    case actions.ActionTypes.SET_DOCUMENTS_FROM:
      return {
        ...state, pagination: {
          page: 1,
          itemsByPage: 10,
          total: 0,
        }, filter: { ...state.filter, from: action.payload }
      };

    case actions.ActionTypes.SET_DOCUMENTS_TO:
      return {
        ...state, pagination: {
          page: 1,
          itemsByPage: 10,
          total: 0,
        }, filter: { ...state.filter, to: action.payload }
      };

    case actions.ActionTypes.SET_DOCUMENTS_SORT:
      return { ...state, sort: action.payload };

    case actions.ActionTypes.SET_DOCUMENTS_PAGINATION:
      return { ...state, pagination: action.payload };

    case actions.ActionTypes.RESET_DOCUMENTS:
      return { ...initialState, filter: { ...state.filter } };

    default:
      return state;
  }
}

